module.exports = __webpack_public_path__ + "static/media/YourName-logo-width-bw-invert.6467d444.png";